import { axios, BaseApiUrl } from '../axios_config';

// 获取移动端上架列表
export const getPutOnList = params =>{
    return axios.post(`${BaseApiUrl}/PutOn/GetPutOnList`, { ...params }).then(res => res.data);
}

// 获取移动端上架明细
export const getPutOnDetail = params =>{
    return axios.get(`${BaseApiUrl}/PutOn/GetPutOn`, { params }).then(res => res.data);
}

// 获取移动端箱明细
export const getPutOnBox = params =>{
    return axios.get(`${BaseApiUrl}/PutOn/GetPutOnBox`, { params }).then(res => res.data);
}

// 移动端确认箱规
export const submitPutOnBox = params =>{
    return axios.post(`${BaseApiUrl}/PutOn/SubmitPutOnBox`, { ...params }).then(res => res.data);
}

// 移动端确认上架
export const submitPutOnDetail = params =>{
    return axios.post(`${BaseApiUrl}/PutOn/SubmitPutOnDetail`, { ...params }).then(res => res.data);
}

// 移动端强制完成
export const overPutOn = params =>{
    return axios.post(`${BaseApiUrl}/PutOn/OverPutOn`, { ...params }).then(res => res.data);
}